import { useTranslation } from 'react-i18next'
import Skeleton from '~/components/Exchange/components/Skeleton'
import { StyledDetailWrapper } from '~/components/Exchange/styled'
import { StyledDetailValue } from '../styled'

interface Props {
  loading: boolean
  estimatedSec?: number
}

const CrossEstimatedTime: React.FC<Props> = ({
  loading,
  estimatedSec = 300,
}) => {
  const { t } = useTranslation()

  const formatEstimatedTime = (seconds: number) => {
    const mins = Math.ceil(seconds / 60)
    return `~${mins}min`
  }

  return (
    <StyledDetailWrapper>
      <span>{t('estimate_swap_complete_time')}</span>
      {loading ? (
        <Skeleton />
      ) : (
        <StyledDetailValue>
          {formatEstimatedTime(estimatedSec)}
        </StyledDetailValue>
      )}
    </StyledDetailWrapper>
  )
}

export default CrossEstimatedTime
